module.exports = __webpack_public_path__ + "static/media/ramazan-desktop-banner-2025.5f3856f5.jpg";